module.exports = __webpack_public_path__ + "img/may-red.f966ee36.svg";